'use client'

import classNames from '@/utils/classNames'
import Image from 'next/image'
import type { Mode } from '@/@types/theme'
import Cart from '@/components/template/Cart'
import Search from '@/components/template/Search'
import { LocationInfo } from './LocationInfo'
import DrawerBase from './DrawerBase'
import Link from 'next/link'
import CallButton from './CallButton'

type NavigationProps = {
    // toggleMode?: () => void
    // mode?: Mode
    pathConfig?: any
}

const Navigation = ({ pathConfig }: NavigationProps) => {
    return (
        <header
            style={{ transition: 'all 0.2s ease-in-out' }}
            className={classNames(
                'w-full top-0 inset-x-0 z-50 relative lg:fixed lg:top-4',
            )}
        >
            <div
                className={classNames(
                    'hidden lg:flex bg-white dark:bg-gray-800 shadow-lg  flex-row self-start items-center  max-w-7xl mx-auto py-3 px-4 rounded-xl relative z-[60] w-full transition duration-200',
                    // isSticky
                )}
            >
                <Link href="/">
                    <div className="flex items-center gap-3 mr-4 shrink-0">
                        <Image
                            src="/image/logo/logo-mini.png"
                            width={200}
                            height={80}
                            alt="logo"
                        />
                        {/* <div className="text-pimary-hover text-base whitespace-nowrap text-[var(--text-4xl)] leading-[var(--text-4xl--line-height)] font-bold" >
                            МаркетСИЗ
                        </div> */}
                    </div>{' '}
                </Link>

                {/* className="flex bg-gray-200 text-gray-700 rounded-xl min-h-[50px] px-3 items-center gap-4 w-full hover:bg-gray-300" */}
                <div className="flex-1 min-w-0">
                    <Search
                        className="
        flex
        bg-gray-200
        text-gray-700
        rounded-xl
        min-h-[50px]
        px-3
        items-center
        gap-4
        hover:bg-gray-300
        w-full
    "
                    />
                </div>

                <div className="flex items-center gap-4 shrink-0">
                    <LocationInfo />
                    <div className="flex items-center gap-3">
                        {/* <UserProfileDropdown hoverable={false} /> */}
                        <Cart />
                        <DrawerBase pathConfig={pathConfig} />
                    </div>
                </div>
            </div>

            {/* mobile */}
            <div className="flex flex-col lg:hidden w-full gap-2 bg-white py-3 mx-auto px-4">
                <div className="flex justify-between items-center w-full">
                    <div className="flex flex-col items-center">
                        <Image
                            src="/image/logo/logo.jpg"
                            width={50}
                            height={60}
                            alt="logo"
                        />
                        <div className="text-pimary-hover mt-2 text-base whitespace-nowrap leading-[var(--text-4xl--line-height)] font-bold">
                            МаркетСИЗ
                        </div>
                    </div>

                    <LocationInfo />
                    <CallButton />
                </div>

                <div className="flex items-center gap-2">
                    <Search className="flex bg-gray-200 text-gray-700 rounded-xl min-h-[50px] px-3 items-center gap-4 w-full hover:bg-gray-300" />
                    <DrawerBase pathConfig={pathConfig} />
                </div>
            </div>
        </header>
    )
}

export default Navigation
